module.exports = __webpack_public_path__ + "static/img/0544_2.6cf4633.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0544_2.jpg
// module id = Wdsm
// module chunks = 1